import React from 'react';

export const ProcessingRightImage = ({ normalizedFacility }) => { // Change prop name
  if (normalizedFacility === "China") { // Use normalizedFacility
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/processing/processing-cn-right.jpeg")`}}></div>);		  
  } else if (normalizedFacility === "Montreal") { // Use normalizedFacility
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/processing/processing-mtl.jpg")`}}></div>);	
  } else {
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/processing/processing-usa.jpg")`}}></div>);			  
  }
};